import {Component, EventEmitter, Input, OnInit, Output, Renderer2} from '@angular/core';
import {AchooFilterBoxComponent} from '../../../../core/achoo-filter-box/achoo-filter-box.component';
import {UserService} from '../../../../services/user.service';
import {ValidationHandlerService} from '../../../../core/validation-handler.service';
import {Page, TargetType, UserActionType} from '../../../../services/event-tracker/event-tracker.service';
import {InfluencerService} from '../../../../services/influencer/influencer.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
  selector: 'demographic-source-selection',
  templateUrl: './demographic-source-selection.component.html',
  styleUrls: ['./demographic-source-selection.component.scss']
})
export class DemographicSourceSelectionComponent extends AchooFilterBoxComponent implements OnInit {
  @Input() dataSources: any[];
  @Output() selectDemographicSourceEvent = new EventEmitter<any>();
  public mpEventData = {
    action: UserActionType.VIEW,
    item: Page.DEMOGRAPHICS,
    target: {
      id: this.influencerService.influencerDetails.id,
      name: this.influencerService.influencerDetails.name,
      type: TargetType.INFLUENCER
    }
  };

  constructor(private userService: UserService,
              private influencerService: InfluencerService,
              public validationHandlerService: ValidationHandlerService,
              protected renderer: Renderer2,
              private deviceDetector: DeviceDetectorService) {
    super(validationHandlerService, deviceDetector, renderer);
  }

  ngOnInit() {
    super.ngOnInit();
    this.disabled = this.userService.isFreeUser() && !this.userService.isAdmin;
  }

  onSelectDemographicSource(evt) {
    this.selectDemographicSourceEvent.emit(evt);
  }

  get selectPlatform() {
    const selectSource = this.dataSources.find(s => s.id === this.model);
    return selectSource ? selectSource.platformName : '';
  }

  get eventData() {
    return {
      action: UserActionType.VIEW,
      item: Page.DEMOGRAPHICS,
      target: {
        id: this.influencerService.influencerDetails.id,
        name: this.influencerService.influencerDetails.name,
        type: TargetType.INFLUENCER
      }
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/demographic/demographic-source-selection/demographic-source-selection.component.ts